import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

import { QualificationPage, UnderlyingPoliciesPage, VehicleDriverHouseHoldDetailsPage, WatercraftLocationBusinessDetailsPage } from 'ml-capability-quoteandbind-common-react';
import PUPAdditionalInfoToPurchasePage from './pages/PUPAdditionalInfoToPurchase/PUPAdditionalInfoToPurchasePage';

setComponentMapOverrides(
    {
        PUPQualificationPage: { component: 'PUPQualificationPage' },
        PUPUnderlyingPoliciesPage: { component: 'PUPUnderlyingPoliciesPage' },
        VehicleDriverHouseHoldDetailsPage: { component: 'VehicleDriverHouseHoldDetailsPage' },
        WatercraftLocationBusinessDetailsPage: { component: 'WatercraftLocationBusinessDetailsPage' },
        PUPAdditionalInfoToPurchasePage: { component: 'PUPAdditionalInfoToPurchasePage' }
    },
    {
        PUPQualificationPage: QualificationPage,
        PUPUnderlyingPoliciesPage: UnderlyingPoliciesPage,
        VehicleDriverHouseHoldDetailsPage: VehicleDriverHouseHoldDetailsPage,
        WatercraftLocationBusinessDetailsPage: WatercraftLocationBusinessDetailsPage,
        PUPAdditionalInfoToPurchasePage: PUPAdditionalInfoToPurchasePage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PEPUPWizard } from './PEPUPWizard';